<div class="h-full flex flex-col bg-gray-100 rounded-2xl p-4">
  <!-- Header with back button -->
  <div class="py-2 px-6 mb-6">
    <div class="flex items-center gap-4 mb-4">
      <button 
        class="p-2 rounded-md hover:bg-gray-200 transition-colors"
        (click)="cancel()"
      >
        <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7"></path>
        </svg>
      </button>
      <h2 class="text-3xl font-bold">Add New Operator</h2>
    </div>
  </div>

  <div class="flex-1 overflow-auto">
    <div class="max-w-xl mx-auto">
      <!-- Success Message -->
      @if (success()) {
        <div class="bg-green-50 border border-green-200 rounded-2xl p-6 mb-6">
          <div class="flex items-center gap-3">
            <svg class="w-6 h-6 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"></path>
            </svg>
            <div>
              <h3 class="font-semibold text-green-800">Operator created successfully!</h3>
              <p class="text-green-700 text-sm">A password reset email has been sent to the operator.</p>
            </div>
          </div>
        </div>
      }

      <!-- Error Message -->
      @if (error()) {
        <div class="bg-red-50 border border-red-200 rounded-2xl p-4 mb-6">
          <div class="flex items-center gap-3">
            <svg class="w-5 h-5 text-red-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path>
            </svg>
            <span class="text-red-700">{{ error() }}</span>
          </div>
        </div>
      }

      <!-- Form -->
      @if (!success()) {
        <div class="bg-white rounded-2xl p-6 shadow-md">
          <form (ngSubmit)="createOperator()" class="space-y-6">
            <!-- Operator Name -->
            <div>
              <label for="operatorName" class="block text-sm font-medium text-gray-700 mb-2">
                Operator Name
              </label>
              <input
                type="text"
                id="operatorName"
                [ngModel]="operatorName()"
                (ngModelChange)="operatorName.set($event)"
                name="operatorName"
                placeholder="Enter operator name"
                class="w-full px-4 py-3 bg-gray-50 rounded-xl border border-gray-200 text-gray-700 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-200 focus:border-blue-400 transition"
                [disabled]="loading()"
              />
            </div>

            <!-- Operator Email -->
            <div>
              <label for="operatorEmail" class="block text-sm font-medium text-gray-700 mb-2">
                Email Address
              </label>
              <input
                type="email"
                id="operatorEmail"
                [ngModel]="operatorEmail()"
                (ngModelChange)="operatorEmail.set($event)"
                name="operatorEmail"
                placeholder="Enter email address"
                class="w-full px-4 py-3 bg-gray-50 rounded-xl border border-gray-200 text-gray-700 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-200 focus:border-blue-400 transition"
                [disabled]="loading()"
              />
            </div>

            <!-- Info Box -->
            <div class="bg-blue-50 border border-blue-200 rounded-xl p-4">
              <div class="flex items-start gap-3">
                <svg class="w-5 h-5 text-blue-600 mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path>
                </svg>
                <p class="text-sm text-blue-700">
                  The operator will receive an email with a link to set their password.
                </p>
              </div>
            </div>

            <!-- Buttons -->
            <div class="flex justify-end gap-4 pt-4">
              <button
                type="button"
                (click)="cancel()"
                class="px-6 py-3 rounded-xl border border-gray-300 text-gray-700 font-medium hover:bg-gray-50 transition"
                [disabled]="loading()"
              >
                Cancel
              </button>
              <button
                type="submit"
                class="px-6 py-3 rounded-xl bg-gradient-to-r from-blue-600 to-purple-600 hover:from-blue-700 hover:to-purple-700 text-white font-semibold shadow-lg transition-all duration-300 disabled:opacity-50 disabled:cursor-not-allowed"
                [disabled]="loading()"
              >
                @if (loading()) {
                  <span class="flex items-center gap-2">
                    <svg class="animate-spin w-5 h-5" fill="none" viewBox="0 0 24 24">
                      <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                      <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                    </svg>
                    Creating...
                  </span>
                } @else {
                  Create Operator
                }
              </button>
            </div>
          </form>
        </div>
      }
    </div>
  </div>
</div>
